import i18n from '@/utils/i18n'

/** Короткие подписи ролей для шаблонов / лога (без контекста компании). */
export function roleLabelForTemplate(role: string): string {
  switch (role) {
    case 'admin':
      return i18n.t('notif.templateRole.admin')
    case 'dispatcher':
      return i18n.t('notif.templateRole.dispatcher')
    case 'manager':
      return i18n.t('notif.templateRole.manager')
    case 'customer_supervisor':
      return i18n.t('notif.templateRole.customer_supervisor')
    case 'contractor_supervisor':
      return i18n.t('notif.templateRole.contractor_supervisor')
    case 'inspector':
      return i18n.t('notif.templateRole.inspector')
    default:
      return role
  }
}

/** Метка события-триггера на текущем языке интерфейса (i18n-backed). */
export function triggerEventLabel(eventType: string): string {
  const key = `notif.eventLabel.${eventType}`
  const label = i18n.t(key)
  return label === key ? eventType : label
}
